export default {
  wantToAsk: "我想问", //注册
  vip: "会员相关", //注册
  feedBack: "人工客服", //! 使用feedback_title
  creatorServiceCenter: "创作者服务中心", //! 使用creator_service_center 
  inputPlaceholder: "输入您的宝贵意见", //注册
  send: "发送", //使用ksalbum_send
  pic: "图片", // 使用picture_2
  video: "视频", // 使用 photopick_video
  picLimit: "上传图片大小不能超过20M", //注册
  noIssue: "上述没有我想要的问题", //注册
  noMessage: "没有更多历史消息～", // 使用noHistoryMessage
  inputEmpty: "您输入的内容为空！",  //注册
  maxLength: "最多仅支持输入500字！", //注册
  inputContact: "请输入您的联系方式，让我们更好的为您服务～", //注册完
  netError: "网络错误，请检查您的网络", //注册
  netTimeout: "网络超时，请检查您的网络", //注册
  thanksFeedback: "收到您的反馈，我们将会及时处理", //注册

  contactInformation: "联系方式", //注册
  contact: "QQ/Email/手机号", //注册
  uploading: "上传中...", //使用 uploading__
  uploadLimit: "上传视频大小不能超过150M", //注册
  videoNotSupport: "不支持该视频格式", //注册
  inviteFeedback: "邀请您填写对我们的意见反馈", //注册
  inviteDesc:
    "如您对产品功能、使用体验上有改进建议意见，可以提交给我们。我们会第一时间反馈相关信息进行优化", //注册
  inviteBtn: "填写意见反馈", //注册
  draftDialogTitle: "草稿上传", //注册
  draftDialogDesc: //注册
    "为了更快的解决问题，请您授权系统上传您最近一次的草稿及素材，草稿及素材仅用于分析问题，如果您拒绝该授权，我们可能无法及时解决您的问题。", 
  deny: "拒绝",  // 使用livelink_jump_refuse
  accept: "同意", // 使用agree
  kwaiCut: {
    slogan: "快影，创作有趣的视频", // 使用str_kuaiying_create_fun_videos
    subtitle: "段子、游戏和美食等视频编辑",
    desc: "快手旗下视频编辑手机应用",
    scanDownload: "扫码下载 快影",
    featTitle1: "全面的视频剪辑",
    featDesc1: "倒放、变速和转场等功能，一应俱全",
    featTitle2: "精致的短视频编辑",
    featDesc2: "精美滤镜和字幕，视频秒变大片",
    featTitle3: "一键分享快手",
    featDesc3: "可将视频直接分享至快手",
    featTitle4: "搞笑音效库",
    featDesc4: "100 种热门音效，让你的段子更受欢迎",
    featTitle5: "自定义封面字体",
    featDesc5: "想上热门？吸引眼球的封面至关重要",
  },
};
